import { showToast } from "../redux/slices/Toasts";
import { useAppSelector, useAppDispatch } from "../redux/hooks";
import { InternalResponse, ServerResponse } from "../models/common/responseObjects";
import _ from "lodash";

export function ResponseHasError(responses: InternalResponse<any>[]): { hasError: boolean, errorMessage: string[] } {

    let hasError: boolean = false;
    let errorMessages: string[] = [];

    responses.forEach((r) => {
        if (r) {
            if (r.error === null || r.error === undefined || r.error === "") {
                //All good!
            } else {
                hasError = true;
                errorMessages.push(r.error);
            }
        }

    })

    return { hasError: hasError, errorMessage: errorMessages };
}

export function ServerResponseHasError(responses: ServerResponse<any>[]): { hasError: boolean, errorMessage: string[] } {
    let hasError: boolean = false;
    let errorMessages: string[] = [];
    responses.forEach((r) => {
        if (r.errors === null || r.errors === undefined || r.errors.length === 0) {
            //All good!
        } else {
            hasError = true;
            errorMessages.push(...r.errors);
        }
    })
    return { hasError: hasError, errorMessage: errorMessages };
}

export function useDisplayError() {
    const dispatch = useAppDispatch();
    const displayError = (errorMessages: string) => {
        if(errorMessages) dispatch(showToast({ value: [errorMessages] }));
    }
    return displayError;
}

// 
/**
 * Pass this into an array.filter() to perform the equivalent of .Distinct()
 * @returns An array containing only unique values
 */
export function onlyUnique(value: any, index: number, array: any[]) {
    return array.indexOf(value) === index;
}

String.prototype.containsKeyword = function(searchKeyword: string) {
    return this.valueOf().toLocaleLowerCase().includes(searchKeyword.toLocaleLowerCase());
}


/**
 * Returns the week number for this date.  dowOffset is the day of week the week
 * "starts" on for your locale - it can be from 0 to 6. If dowOffset is 1 (Monday),
 * the week returned is the ISO 8601 week number.
 * @param int dowOffset
 * @return int
 */
Date.prototype.getWeek = function (dowOffset: number) {
    /*getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.meanfreepath.com */
    
        dowOffset = typeof(dowOffset) == 'number' ? dowOffset : 0; //default dowOffset to zero
        var newYear = new Date(this.getFullYear(),0,1);
        var day = newYear.getDay() - dowOffset; //the day of week the year begins on
        day = (day >= 0 ? day : day + 7);
        var daynum = Math.floor((this.getTime() - newYear.getTime() - 
        (this.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
        var weeknum;
        //if the year starts before the middle of a week
        if(day < 4) {
            weeknum = Math.floor((daynum+day-1)/7) + 1;
            if(weeknum > 52) {
                var nYear = new Date(this.getFullYear() + 1,0,1);
                var nday = nYear.getDay() - dowOffset;
                nday = nday >= 0 ? nday : nday + 7;
                /*if the next year starts before the middle of
                  the week, it is week #1 of that year*/
                weeknum = nday < 4 ? 1 : 53;
            }
        }
        else {
            weeknum = Math.floor((daynum+day-1)/7);
        }
        return weeknum;
    };



Date.prototype.getQuarter = function() {
    return Math.floor((this.getMonth() + 3) / 3);
}

/**
 * Get the financial quarter for this date. This is different from the regular quarter as it starts in July
 */
Date.prototype.getFinancialQuarter = function() {
    const month = this.getMonth();
    
    if (month < 3) {
        return 3;
    } else if (month < 6) {
        return 4;
    } else if (month < 9) {
        return 1;
    } else {
        return 2;
    }
}

/**
 * Performs the C# equivalent of .GroupBy()
 * @param arr The array to group
 * @param keyFunc The element to group by
 * @returns A map of <K, T[]> where K is the element that's being grouped by and T[] are all the items that fall into that group 
 */
export function groupBy<T, K extends keyof any>(arr: T[], keyFunc: (i: T) => K) {
    return arr.reduce((groups, item) => {
        const key: K = keyFunc(item);
        groups.set(key, [...(groups.get(key) ?? []), item]);
        return groups;
    }, new Map<K, T[]>());
}

/**
 * A method to determine if an array contains duplicates
 * @param array 
 * @returns 
 */
export function hasDuplicates(array: unknown[]) {
    return (new Set(array)).size !== array.length;
}

export function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

// Extend the global Array interface
declare global {
    interface String {
        containsKeyword(searchKeyword: string): boolean;
    }
    interface Date {
        getWeek(dowOffset: number): number;
        getQuarter(): number;
        getFinancialQuarter(): number;
    }
    interface Array<T> {
    /**
     * Returns an array that has items removed that are duplicates based on the callback that is passed in
     * @param identifierCallback If the callback value for this item matches the callback value of another item in the array it's considered a duplicate to be removed.
     */
      removeDuplicates(identifierCallback: (item: T) => any): T[];
    }
  }
  
  // Implement the method if it doesn't already exist to avoid conflicts
  if (!Array.prototype.removeDuplicates) {
    Array.prototype.removeDuplicates = function<T>(this: T[], identifierCallback: (item: T) => any): T[] {
      return this.filter((item, index, self) =>
        index === self.findIndex((t) => (
          _.isEqual(identifierCallback(t), identifierCallback(item))
        ))
      );
    };
  }
  
  
  export {};